import React, { Fragment } from 'react'
import "./utils.css" ; 
import PageSearchItem from './PageSearchItem';
import { STATUS } from '../../Constants';
import PageSearchItemLoading from './PageSearchItemLoading';
import PageSearchItemModified from './PageSearchItemModified';

const PageSearchList = ({data , status}) => {

  return (
    <div  className='search-page-container'>
        {
            status === STATUS.SUCCESS ? 
            data.length > 0 ? 
            data.map((item)=>{
                return(<PageSearchItemModified verified={item.verification_status ==="blue_verified"} key={item.id} name={item?.name} id={item?.id} location={item?.location}  />)
            })
            :"":""
        }

        {
            status === STATUS.LOADDING ? (
              <Fragment>
                <PageSearchItemLoading />
              </Fragment>
            ) :""
        }


    </div>
  )
}

export default PageSearchList
